module.exports = __webpack_public_path__ + "img/01.25d85e57.jpg";